import SmallNumberBox from './SmallNumberBox'
import revenueIcon from './icons/revenue_icon.svg'
import Image from 'next/image'

type RevenuesBoxProps = {
  animationProps: any
  title: string
  backgroundColor?: string
  borderColor?: string
  year: string
  revenue: string | number
  revenueLabel: string
}
const RevenuesBox = ({
  animationProps,
  title,
  backgroundColor = '#266782',
  borderColor = '#266782',
  year,
  revenue,
  revenueLabel,
}: RevenuesBoxProps) => {
  return (
    <SmallNumberBox
      animationProps={animationProps}
      title={title}
      titleColor="white"
      backgroundColor={backgroundColor}
      borderColor={borderColor}
    >
      <div className="revenue-icon-inner">
        <div className="sm:text-4.5xl mb-6 pb-4 text-4xl normal-case text-white no-underline">
          {year}
        </div>
        <Image src={revenueIcon} alt="revenue" />
        <div className="text-center text-3xl text-white">
          {revenue}
          <span className="ml-2.5 text-center text-base">{revenueLabel}</span>
        </div>
      </div>
    </SmallNumberBox>
  )
}

export default RevenuesBox
